import { defineComponent, h } from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { button } from '@/ui/components';
import HtmlHelper, { CanvasDataFormats } from '@/ui/helpers/HtmlHelper';
import { v4 as uuidv4 } from 'uuid';
import { PartialExcept } from '@/types';

interface DownloadQrCodeButtonProps {
  buttonText: string;
  buttonDisabled: boolean;
  qrCodeData: string;
  qrCodeHeight: number;
  qrCodeWidth: number;
  qrCodeImageName: string;
  qrCodeImageFormat: CanvasDataFormats;
  htmlHelper: HtmlHelper;
}

const DownloadQrCodeButton = defineComponent<DownloadQrCodeButtonProps>({
  name: 'DownloadQrCodeButton',
  props: ['buttonText', 'buttonDisabled', 'qrCodeData', 'qrCodeHeight', 'qrCodeWidth', 'getCanvasData', 'downloadData',
    'qrCodeImageName', 'qrCodeImageFormat', 'htmlHelper'],
  setup(props) {
    const qrCodeElementId = `downloadableQrCode-${uuidv4()}`;

    const download = () => {
      props.htmlHelper.getLinkElementToDownloadCanvasData(
        props.qrCodeImageName,
        qrCodeElementId,
        props.qrCodeImageFormat,
      ).click();
    };

    return function render() {
      return h('div', [
        h('div', {
          class: 'hidden',
        }, [
          h(VueQrcode, {
            props: {
              value: props.qrCodeData,
              options: {
                height: props.qrCodeHeight,
                width: props.qrCodeWidth,
              },
            },
            attrs: { id: qrCodeElementId },
          }),
        ]),
        button(props.buttonText, download, undefined, { disabled: props.buttonDisabled }),
      ]);
    };
  },
});

export type DownloadQrCodeButtonOptions =
  Omit<PartialExcept<DownloadQrCodeButtonProps, 'buttonText' | 'buttonDisabled'| 'qrCodeData'>, 'htmlHelper'>;

export function makeDownloadQrCodeButton({
  buttonText,
  buttonDisabled,
  qrCodeData,
  qrCodeHeight = 1000,
  qrCodeWidth = 1000,
  qrCodeImageName = 'qrcode.png',
  qrCodeImageFormat = CanvasDataFormats.Png,
}: DownloadQrCodeButtonOptions) {
  return h(DownloadQrCodeButton, {
    props: {
      buttonText,
      buttonDisabled,
      qrCodeData,
      qrCodeHeight,
      qrCodeWidth,
      qrCodeImageName,
      qrCodeImageFormat,
      htmlHelper: new HtmlHelper(),
    },
  });
}
